<template>
  <div>
    <vs-breadcrumb
      class="mb-6"
      :items="[
        {
          title: '商品',
          url: '/goods/list',
        },
        {
          title: '创建新商品',
          active: true,
        },
      ]"
    ></vs-breadcrumb>

    <!-- <div class="vx-row">
    <div class="vx-col md:1">-->
    <vx-card title="创建新商品" class="mb-6">
      <vs-divider position="left" class="text-bold">基本信息</vs-divider>
      <template>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full flex flex-row-reverse">
            <span>商品名称</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <vs-input class="w-full" v-model="name" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full flex flex-row-reverse">
            <span>商品广告语</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <vs-input class="w-full" v-model="slogan" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full flex flex-row-reverse">
            <span>商品分类</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <v-select :options="categoryList" label="name" v-model="category" />
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full flex flex-row-reverse">
            <span>单位(默认规格)</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <div class="vx-row">
              <div class="vx-col sm:w-1/4 w-full">
                <vs-input
                  class="w-full"
                  v-model="unit"
                  placeholder="单位(默认规格)"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full flex flex-row-reverse">
            <span>单价/市场价<br />采购价/运费</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <div class="vx-row">
              <div class="vx-col sm:w-1/4 w-full">
                <vs-input
                  class="w-full"
                  v-model="price"
                  type="number"
                  placeholder="单价"
                />
              </div>
              <div class="vx-col sm:w-1/4 w-full">
                <vs-input
                  class="w-full"
                  v-model="market_price"
                  type="number"
                  placeholder="市场价"
                />
              </div>
              <div class="vx-col sm:w-1/4 w-full">
                <vs-input
                  class="w-full"
                  v-model="purchase_price"
                  placeholder="采购价"
                />
              </div>
              <div class="vx-col sm:w-1/4 w-full">
                <vs-input class="w-full" v-model="express" placeholder="运费" />
              </div>
            </div>
          </div>
        </div>

        <!-- 供应商ui -->
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full flex flex-row-reverse">
            <span>供应商</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <v-select
              :options="merchantList"
              label="name"
              v-model="merchant"
              :value="merchant ? merchant.name : ''"
            />
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full flex flex-row-reverse">
            <span>是否团购</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <div class="vx-row">
              <div class="vx-col sm:w-1/4 w-full">
                <ul class="con-s">
                  <li>
                    <!-- <div class="mb-1">{{group_type === 2?'团购':'非团购'}}</div> -->
                    <vs-switch
                      v-model="groupTypeCheck"
                      @input="changeGroupType(groupTypeCheck)"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-row mb-6" v-if="groupTypeCheck">
          <div class="vx-col sm:w-1/6 w-full flex flex-row-reverse">
            <span>团购信息</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <div class="vx-row">
              <div class="vx-col sm:w-1/4 w-full">
                <vs-input
                  class="w-full"
                  v-model="group_price"
                  type="number"
                  placeholder="团购价"
                />
              </div>
              <div class="vx-col sm:w-1/4 w-full">
                <vs-input
                  class="w-full"
                  v-model="group_persons"
                  type="number"
                  placeholder="团购人数"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full flex flex-row-reverse">
            <span>商品销售规格</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <vs-alert active="true" class="mb-6"
              >如不添加规格, 按默认单价单位销售</vs-alert
            >
            <div class="flex">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="addSpec"
                class="mr-3"
                >添加商品规格</vs-button
              >
              <vs-button
                v-if="goodsSpecs.length > 0"
                color="primary"
                type="border"
                icon-pack="feather"
                icon="icon-x"
                @click="clearSpec"
                >清空已添加的规格</vs-button
              >
            </div>

            <div class="mt-5">
              <div class v-if="selectedSpec">规格名称: {{ selectedSpec }}</div>
              <div class="mt-2" v-if="goodsSpecs.length > 0">
                <vs-table :data="goodsSpecs" noDataText="还没有添加规格" stripe>
                  <template slot="thead">
                    <vs-th width="12%">操作</vs-th>
                    <vs-th>#</vs-th>
                    <vs-th with="10%">规格值</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr :key="index" v-for="(item, index) in data">
                      <vs-td>
                        <a
                          href="javascript:void(0)"
                          @click="delSpecItem"
                          :data-spec="item"
                          >删除</a
                        >
                      </vs-td>

                      <vs-td>{{ index + 1 }}</vs-td>
                      <vs-td>{{ item }}</vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
      </template>
      <vs-divider position="left" class="text-bold">商品图片</vs-divider>
      <template>
        <div class="vx-row">
          <div class="vx-col sm:w-1/6 w-full flex flex-row-reverse">
            <span>商品分享封面图</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <div>
              <vs-alert active="true" class>
                尺寸: 800*640(宽高比5:4), 支持的图片格式: jpg, jpeg, png
              </vs-alert>
              <div class>
                <vs-upload
                  :action="uploadImgUrl"
                  fileName="file"
                  :data="uploadCoverData"
                  @on-success="successUpload"
                  @on-error="showUploadError"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col sm:w-1/6 w-full flex flex-row-reverse">
            <span>商品轮播图</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <div>
              <vs-alert active="true" class>
                尺寸: 800*800(宽高比1:1), 支持的图片格式: jpg, jpeg, png
              </vs-alert>
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class>
                    <vs-upload
                      class
                      :action="uploadImgUrl"
                      fileName="file"
                      :data="uploadSwiperData"
                      @on-success="successUpload"
                      @on-error="showUploadError"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col sm:w-1/6 w-full flex flex-row-reverse">
            <span>商品详情图</span>
          </div>
          <div class="vx-col sm:w-5/6 w-full">
            <div>
              <vs-alert active="true" class
                >尺寸不做限制, 支持的图片格式: jpg, jpeg, png</vs-alert
              >
              <div class>
                <vs-upload
                  :action="uploadImgUrl"
                  fileName="file"
                  :data="uploadImageData"
                  @on-success="successUpload"
                  @on-error="showUploadError"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
      <vs-divider position="left" class="text-bold"
        >确认以上信息无误, 提交创建表单</vs-divider
      >
      <div class="vx-row">
        <div class="vx-col w-full flex justify-center">
          <vs-button class="mr-3 mb-2" @click="submitData">提交创建</vs-button>
          <vs-button
            color="primary"
            type="border"
            class="mb-2"
            @click="name = slogan = express = unit = price = market_price = ''"
            >重置</vs-button
          >
        </div>
      </div>
    </vx-card>
    <!-- </div>
    </div>-->

    <vs-popup :title="addSpecPopUpTitle" :active.sync="addSpecPopUpActive">
      <div class>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label class="mb-5">规格名称</label>
            <v-select
              :options="specs"
              taggable
              push-tags
              v-model="selectedSpec"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
            />
          </div>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col w-full">
            <label class="mb-5">规格值</label>
            <vs-input class="w-full" v-model="specValue" />
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3" @click="addSpecConfirm">添加</vs-button>
            <vs-button type="border" @click="closeSpecPopUp">关闭</vs-button>
            <vs-alert :active="isShowMsg" class="mt-4">{{ msg }}</vs-alert>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup :title="popUpTitle" :active.sync="popUpActive">
      <div>{{ popUpMsg }}</div>
      <div class="flex mt-3">
        <vs-button class="mr-3" @click="confirmClearSpec">确定清空</vs-button>
        <vs-button type="border" @click="cancelClearSpec">取消</vs-button>
      </div>
    </vs-popup>

    <vs-popup title="操作提示" :active.sync="createPopUpActive">
      <div>是否确定创建新商品?</div>
      <div class="flex mt-3">
        <vs-button class="mr-3" @click="confirmCreate" :disabled="btnDisabled"
          >确定创建</vs-button
        >
        <vs-button type="border" @click="cancelCreate" :disabled="btnDisabled"
          >取消</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>
<script>
import specsRepo from '@/repo/specs'
import goodsRepo from '@/repo/goods'
import merchantRepo from '@/repo/merchant'
import categoryRepo from '@/repo/category'
import vSelect from 'vue-select'
export default {
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      merchant: {
        id: '',
        name: '',
      },
      merchantList: [],
      btnDisabled: false,
      isShowMsg: false,
      msg: '',
      name: '',
      slogan: '',
      purchase_price: '',
      price: '',
      market_price: '',
      groupTypeCheck: false,
      group_type: 1,
      group_persons: '',
      group_price: '',
      unit: '',
      express: '',
      category: null,
      categoryList: [],
      uploadImgUrl: `${env.API_HOST}admin/goods/image/upload`,
      uploadCoverData: {
        type: 1,
      },
      uploadSwiperData: {
        type: 2,
      },
      uploadImageData: {
        type: 3,
      },
      uploadType: 1,
      image: '', //封面
      swipers: [], //轮播图
      images: [], //详情图
      specs: [],
      showSpec: '',
      specValue: '',
      goodsSpecs: [],
      addSpecPopUpTitle: '添加商品规格',
      addSpecPopUpActive: false,
      popUpActive: false,
      popUpTitle: '操作提示',
      popUpMsg: '',
      selectedSpec: null,
      createPopUpActive: false,
      postData: null,
    }
  },
  mounted() {
    this.getSpecsList()
    this.getCategoryList()
    this.getMerchantList()
    //从本地获取信息
    let goodsSpecs = localStorage.getItem('goodsSpecs') || []

    if (goodsSpecs.length > 0) {
      goodsSpecs = JSON.parse(goodsSpecs)
    }
    const selectedSpec = localStorage.getItem('selectedSpec')
    this.goodsSpecs = goodsSpecs
    this.selectedSpec = selectedSpec
  },
  methods: {
    // getMerchantList: function () {
    //   merchantRepo.list((error, data) => {
    //     const merchantList = data
    //     // console.log('供应商列表', merchantList)
    //     this.merchantList = merchantList
    //   })
    // },
    getMerchantList: function () {
      merchantRepo.getPullStoreList((error, data) => {
        const merchantList = data.data.map((v) => {
          return { id: v.id, name: v.store_name }
        })
        // const merchantList = data.data
        //console.log('merchantList list:', merchantList)
        this.merchantList = merchantList
      })
    },

    //获取分类列表
    getCategoryList: function () {
      categoryRepo.list((error, data) => {
        if (data.code === 0) {
          const categoryList = data.data
          console.log('category list:', categoryList)
          this.categoryList = categoryList
        }
      })
    },

    //获取规格列表
    getSpecsList: function () {
      specsRepo.list((error, data) => {
        if (data.length > 0) {
          const specs = []
          data.forEach((element) => {
            specs.push(element.name)
          })
          console.log('specs:', specs)
          this.specs = specs
        }
      })
    },

    successUpload(event) {
      let responseText = event.currentTarget.responseText
      console.log('responseText:', responseText)
      responseText = JSON.parse(responseText)
      this.openNotify(responseText.msg, 'success')
      //刷新seat_image显示
      this.showSeatImage = true
      const image = responseText.data
      const uploadType = Number(responseText.type)

      //如果上传的是封面
      if (uploadType === 1) {
        this.image = image //只保存一张封面
      } else if (uploadType === 2) {
        //如果上传的是轮播图
        const swipers = this.swipers
        swipers.push(image)
        this.swipers = swipers
      } else if (uploadType === 3) {
        //如果上传的是详情图
        const images = this.images
        images.push(image)
        this.images = images
      }
    },

    showUploadError(event) {
      console.log(event)
      if (event.currentTarget.status === 400) {
        let responseText = event.currentTarget.responseText
        console.log('responseText:', responseText)
        responseText = JSON.parse(responseText)
        this.openNotify(responseText.msg)
      }
    },

    //添加规格
    addSpec: function () {
      this.addSpecPopUpActive = true
      this.specValue = ''
    },

    //打开清空规格对话框
    clearSpec: function () {
      this.popUpActive = true
      this.popUpMsg = '是否清空已添加的规格?'
    },

    //确认清空规格
    confirmClearSpec: function () {
      this.selectedSpec = null
      this.goodsSpecs = []
      this.specValue = ''
      this.popUpMsg = ''
      this.popUpActive = false
    },

    //取消清空规格
    cancelClearSpec: function () {
      this.popUpActive = false
    },

    //关闭规格表单
    closeSpecPopUp: function () {
      this.addSpecPopUpActive = false
    },

    //确认添加规格
    addSpecConfirm: function () {
      const goodsSpecs = this.goodsSpecs
      const selectedSpec = this.selectedSpec

      if (selectedSpec === null) {
        this.showAlert('请填写或选择一个规格名称')
      } else if (this.specValue === '') {
        this.showAlert('请填写一个规格值')
      } else {
        goodsSpecs.push(this.specValue)
        this.goodsSpecs = goodsSpecs
        localStorage.setItem('goodsSpecs', JSON.stringify(goodsSpecs))
        localStorage.setItem('selectedSpec', selectedSpec)

        this.specValue = ''
      }
    },

    delSpecItem: function (e) {
      const curItem = e.currentTarget.dataset.spec
      console.log('cur item:', curItem)
      const goodsSpecs = this.goodsSpecs
      goodsSpecs.splice(
        goodsSpecs.findIndex((item) => item === curItem),
        1
      )
      this.goodsSpecs = goodsSpecs
      localStorage.setItem('goodsSpecs', JSON.stringify(goodsSpecs))
    },

    //显示错误alert
    showAlert: function (msg) {
      this.isShowMsg = true
      this.msg = msg
      setTimeout(() => {
        this.isShowMsg = false
        this.msg = ''
      }, 1000)
    },

    changeGroupType: function (groupTypeCheck) {
      this.groupTypeCheck = groupTypeCheck

      this.group_type = groupTypeCheck ? 2 : 1
    },

    submitData: function () {
      const category = this.category

      let postData = null
      if (this.name === '') {
        this.openNotify('商品名称不能为空')
      } else if (this.slogan === '') {
        this.openNotify('商品广告语不能为空')
      } else if (this.category === null) {
        this.openNotify('商品分类不能为空')
      } else if (this.unit === '') {
        this.openNotify('单位不能为空')
      } else if (this.price === '' || this.price === 0) {
        this.openNotify('商品价格不能为空或0')
      } else if (!(this.merchant ? this.merchant.id : 0)) {
        this.openNotify('商品供应商不能为空')
        return
      } else if (this.purchase_price === '' || this.purchase_price === 0) {
        this.openNotify('采购价不能为空或0')
      } else if (this.groupTypeCheck) {
        //如果是团购
        if (this.group_price === '' || this.group_price === 0) {
          this.openNotify('团购价格不能为空或0')
        } else if (this.group_price >= this.price) {
          this.openNotify('团购价格需小于零售价格')
        } else if (
          this.group_persons === '' ||
          Number(this.group_persons) < 2
        ) {
          this.openNotify('需设置团购人数且大于1')
        } else {
          this.createPopUpActive = true
        }
      } else {
        this.createPopUpActive = true
      }
      const merchant_id = this.merchant ? this.merchant.id : 0

      //开始提交表单
      postData = {
        store_id: merchant_id,
        name: this.name,
        slogan: this.slogan,
        purchase_price: this.purchase_price,
        price: this.price,
        market_price: this.market_price,
        group_price: this.group_price,
        group_persons: this.group_persons,
        group_type: this.group_type,
        unit: this.unit,
        express: this.express,
        image: this.image,
        swipers: this.swipers,
        images: this.images,
        spec: this.selectedSpec,
        specs: this.goodsSpecs,
        category: this.category,
      }
      this.postData = postData
    },

    confirmCreate: function () {
      this.createGoods()
    },

    cancelCreate: function () {
      this.createPopUpActive = false
    },

    createGoods: function () {
      this.btnDisabled = true
      const postData = this.postData
      console.log('post data:', postData)
      goodsRepo.create(postData, (error, data) => {
        console.log('error', error)
        console.log('data', data)
        this.btnDisabled = false
        let color = 'danger'
        if (data.code === 0) {
          color = 'success'
          //清空表单
          this.goodsSpecs = []
          this.selectedSpec = ''
          localStorage.removeItem('goodsSpecs')
          localStorage.removeItem('selectedSpec')
          this.name =
            this.slogan =
            this.price =
            this.market_price =
            this.unit =
            this.express =
              ''
          this.image = ''
          this.images = []
          this.swipers = []
        }
        this.createPopUpActive = false
        this.openNotify(data.msg, color)
      })
    },

    openNotify: function (msg, color = 'danger') {
      this.$vs.notify({
        position: 'bottom-center',
        color: color,
        title: '操作提示',
        text: msg,
      })
      return false
    },
  },
}
</script>
<style scoped>
.gray {
  background: #f5f5f5;
}

.text-bold {
  font-weight: bold;
}

.upload-content {
  height: 80px;
}
</style>
